// extracted by mini-css-extract-plugin
export default {"btn":"BtnSecondary_btn__tsPog","text":"BtnSecondary_text__XeNvS","rowIcon":"BtnSecondary_rowIcon__3maff","wrappRow":"BtnSecondary_wrappRow__OZuWW"};